import { makeStyles } from '@material-ui/core';

const styles = makeStyles(() => ({
  root: {
    display: 'flex',
    marginBottom: 10,
  },
  cardContent: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  gridVertical: {
    display: 'flex',
    flexDirection: 'column',
  },
  innerGrid: {
    marginBottom: 10,
  },
  iconButton: {
    padding: 5,
    color: 'white',
    borderRadius: 50,
    cursor: 'pointer',
    marginRight: 5,
  },
  headerBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 6,
  },
  headerIconAndTitle: {
    display: 'flex',
    gap: 8,
    alignItems: 'center',
    '& span': {
      fontSize: '0.7vw',
      fontWeight: 'bold',
    },
  },
  summaryRow: {
    display: 'flex',
    gap: 12,
    marginBottom: 6,
  },
  summaryField: {
    flex: 1,
    minWidth: 0,
  },
  summaryValue: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  rsuSectionLabel: {
    marginTop: 4,
    marginBottom: 2,
  },
  ivimSectionTitle: {
    marginTop: 10,
    marginBottom: 8,
  },
  ivimList: {
    margin: 0,
    paddingLeft: 0,
    listStyle: 'none',
  },
  ivimLink: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    background: 'none',
    border: 'none',
    padding: '4px 0',
    cursor: 'pointer',
    textAlign: 'left',
    width: '100%',
    font: 'inherit',
    color: 'inherit',
  },
  faultList: {
    margin: 0,
    paddingLeft: 0,
    listStyle: 'none',
    '& li': {
      marginBottom: 6,
    },
  },
}));

export default styles;
